import SETTINGS from 'src/settings'
import getEnvVar from '@/lib/getEnvVar'

export const getDomainSetting = setting => {
  switch (getEnvVar('APP_ENV')) {
    case 'staging':
      return SETTINGS.staging[setting]
    case 'production':
      return SETTINGS.production[setting]
    default:
      return SETTINGS.dev[setting]
  }
}
